import { Checkbox } from 'antd'
import React, { memo } from 'react'
import styled from 'styled-components'
import { BaseSensorEntry } from 'types'

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 0.125rem;
`

const TagInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const TagName = styled.span`
  font-size: 0.8125rem;
  font-weight: 500;
  color: ${({ theme }) => theme.forecast.activeText};
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const TagDescription = styled.span`
  font-size: 0.625rem;
  color: ${({ theme }) => theme.forecast.defaultText};
  opacity: 0.8;
`

const TagUnit = styled.span`
  font-size: 0.6875rem;
  color: ${({ theme }) => theme.forecast.primary};
`

const QuickResultItem = styled.div<{ $selected?: boolean }>`
  padding: 0.2rem;
  height: 2.5rem;
  cursor: pointer;
  display: flex;
  gap: 0.5rem;
  background: ${({ $selected }) =>
    $selected ? 'rgba(0, 194, 144, 0.1)' : 'transparent'};
  transition: background 0.2s;
  border-bottom: 1px solid ${({ theme }) => theme.forecast.border}1a;
  min-height: fit-content;

  &:hover {
    background: ${({ $selected }) =>
      $selected ? 'rgba(0, 194, 144, 0.15)' : 'rgba(0, 194, 144, 0.08)'};
  }
`

interface RowProps {
  index: number
  style: React.CSSProperties
  data: {
    tags: BaseSensorEntry[]
    selectedTags: BaseSensorEntry[]
    handleTagToggle: (tag: BaseSensorEntry) => void
  }
}

export const Row = memo<RowProps>(({ index, style, data }: RowProps) => {
  const { tags, selectedTags, handleTagToggle } = data
  const tag = tags[index]
  const isSelected = selectedTags.some((t) => t.id === tag.id)

  return (
    <QuickResultItem
      style={style}
      $selected={isSelected}
      onClick={(e) => {
        e.stopPropagation()
        handleTagToggle(tag)
      }}>
      <Checkbox checked={isSelected} />
      <ContentWrapper>
        <TagInfo>
          <TagName title={tag.data.name}>{tag.data.name}</TagName>
          {tag.data.unit && <TagUnit>({tag.data.unit})</TagUnit>}
        </TagInfo>
        {tag.data.asset && <TagDescription>{tag.data.asset}</TagDescription>}
      </ContentWrapper>
    </QuickResultItem>
  )
})

Row.displayName = 'DatapointRow'
